import styled from 'styled-components';

export const ViewContainer = styled.div<{ theme?: any }>`
  width: 100%;
  background-color: ${({ theme }) => theme?.background1 || '#ffffff'};
`;

// Wrapper to hold tabs and navigation buttons
export const RoundsNavigationWrapper = styled.div<{ theme?: any }>`
  position: relative;
  width: 100%;
  margin-top: 12px;
  background-color: ${({ theme }) => theme?.background1 || '#ffffff'};
  border-radius: 8px;
  min-height: 40px; /* Ensure we have enough space for the buttons */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

// Horizontal rounds tabs
export const RoundsTabContainer = styled.div<{ theme?: any }>`
  width: 100%;
  overflow-x: auto;
  padding-bottom: 8px;
  background-color: ${({ theme }) => theme?.background1 || '#ffffff'};
  border-radius: 8px;

  /* Hide scrollbar but keep functionality */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Edge */
  }
  -ms-overflow-style: none; /* IE and Edge */
`;

export const RoundTabs = styled.div<{ needsScrolling?: boolean }>`
  display: flex;
  min-width: min-content;
  gap: 24px;
  padding: 0;
  width: max-content; /* Ensure tabs don't wrap */
`;

export const RoundTab = styled.button<{ isActive: boolean; theme?: any }>`
  background: transparent;
  border: none;
  padding: 8px 4px;
  font-size: 14px;
  font-weight: 600;
  color: ${(props) =>
    props.isActive
      ? props.theme?.text || '#000'
      : props.theme?.textLight || '#6F767E'};
  cursor: pointer;
  position: relative;
  white-space: nowrap;

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: ${(props) =>
      props.isActive ? props.theme?.text || '#000' : 'transparent'};
    transition: background-color 0.2s ease;
  }

  &:hover {
    color: ${({ theme }) => theme?.text || '#000'};
  }
`;

// Add scroll indicator elements
export const ScrollIndicator = styled.div<{
  visible: boolean;
  direction: 'left' | 'right';
  theme?: any;
}>`
  position: absolute;
  top: 0;
  ${(props) => (props.direction === 'left' ? 'left: 0;' : 'right: 0;')}
  height: 100%;
  width: 24px;
  background: ${(props) => {
    // Simple fallback for gradient - use white for light mode, dark for dark mode
    const rgbValues =
      props.theme?.background1?.includes('#1') ||
      props.theme?.background1?.includes('#2')
        ? '30,30,30'
        : '255,255,255';

    return props.direction === 'left'
      ? `linear-gradient(90deg, rgba(${rgbValues},0.8) 0%, rgba(${rgbValues},0) 100%)`
      : `linear-gradient(90deg, rgba(${rgbValues},0) 0%, rgba(${rgbValues},0.8) 100%)`;
  }};
  pointer-events: none;
  opacity: ${(props) => (props.visible ? 1 : 0)};
  transition: opacity 0.2s ease;
  z-index: 1;
`;

// Add scroll buttons for navigation
export const ScrollButton = styled.button<{
  direction: 'left' | 'right';
  visible: boolean;
  theme?: any;
}>`
  position: absolute;
  top: 8px; /* Position buttons properly */
  ${(props) => (props.direction === 'left' ? 'left: 8px;' : 'right: 8px;')}
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme?.background1 || 'white'};
  border: 1px solid ${({ theme }) => theme?.stroke || '#e0e0e0'};
  color: ${({ theme }) => theme?.text || '#333'};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  opacity: ${(props) => (props.visible ? 1 : 0)};
  pointer-events: ${(props) => (props.visible ? 'auto' : 'none')};
  transition: opacity 0.2s ease, background-color 0.2s ease, transform 0.2s ease;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);

  &:hover {
    background-color: ${({ theme }) => theme?.background3 || '#f5f5f5'};
    transform: scale(1.05);
  }

  &:active {
    background-color: ${({ theme }) => theme?.background3 || '#eeeeee'};
    transform: scale(0.95);
  }
`;
